import React from 'react';

const InfoOvernachten = () => {
    return (
        <>
            <h1>Info Overnachten</h1>
        </>
    );
}

export default InfoOvernachten;